import { generateThemeOverride } from '@botpress/webchat'
import { LatestWebchatTheme } from '@bpinternal/shared'
import { useMemo, ReactNode } from 'react'
import { cn } from '~/utils'

type WebchatComponentPreviewProps = {
  theme?: LatestWebchatTheme
  children: ReactNode
  className?: string
}

export const WebchatComponentPreview: React.FC<WebchatComponentPreviewProps> = ({
  theme,
  children,
  className,
}: WebchatComponentPreviewProps) => {
  const styleOverride = useMemo(() => generateThemeOverride({ ...theme }), [theme])

  return (
    <div className={cn('w-full overflow-clip', className)} style={styleOverride}>
      {children}
    </div>
  )
}

export default WebchatComponentPreview
